// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RocketBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19.5 28a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 1 1 0-3h4a1.5 1.5 0 0 1 1.5 1.5ZM16 14.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12.441 5.087-1.545 6.954a2.488 2.488 0 0 1-1.61 1.817 2.484 2.484 0 0 1-2.373-.391L19.647 25.5h-7.292l-3.268 2.468a2.484 2.484 0 0 1-2.372.388 2.487 2.487 0 0 1-1.61-1.816l-1.545-6.953a2.512 2.512 0 0 1 .52-2.142l3.478-4.175c.134-1.564.498-3.1 1.082-4.557 1.659-4.157 4.625-6.763 5.83-7.69a2.5 2.5 0 0 1 3.062 0c1.2.927 4.172 3.533 5.83 7.69a15.875 15.875 0 0 1 1.081 4.557l3.48 4.175a2.512 2.512 0 0 1 .52 2.142ZM12.724 22.5h6.552c2.439-4.462 2.875-8.723 1.299-12.675C19.3 6.625 17.025 4.488 16 3.64c-1.025.847-3.3 2.985-4.575 6.185-1.578 3.953-1.14 8.213 1.299 12.675Zm-2.819 1.09a21 21 0 0 1-2.115-5.913l-1.25 1.5 1.322 5.956 2.043-1.543Zm15.554-4.414-1.25-1.5a20.994 20.994 0 0 1-2.115 5.913l2.041 1.541 1.324-5.954Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
